import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import{ Map } from 'src/jisu-component/map/Map';

import './GoodsDeliveryList.less';

export default class GoodsDeliveryList extends OfficialPage {
  state = {
    deliveryList: [],
    centerLat: '',
    centerLng: '',
    markers: [
      {
        latitude: '',
        longitude: '',
        iconPath: '/images/delivery.png',
        width: 20,
        height: 20
      }
    ],
    deliveryId: '',
    storeStyle: {}
  }
  callout = {
    content: '离您最近的门店地址',
    fontSize: 14,
    color: '#333333',
    borderRadius: 4,
    bgColor: '#ffffff',
    padding: 10,
    display: 'ALWAYS',
    textAlign: 'center'
  }
  franchiseeId = ''
  selfLocation = {}

  constructor(props) {
    super(props);
    document.title = '选择自提点';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.isFranchisee = options.subAppId ? true : false
    this.franchiseeId = options.subAppId || options.franchiseeId || ''
    this.setData({
      deliveryId: options.deliveryId || ''
    })
    this.dataInitial()
  }

  componentDidMount() { }

  dataInitial = () => {
    this.getLocation()
    this.getAppECStoreConfig()
  }
  getLocation = () => {
    let _this = this
    app.getLocation({
      success: function (res) {
        _this.selfLocation = {
          lat: res.latitude,
          log: res.longitude
        }
      },
      fail: function () {
        _this.setData({
          statusFail: true
        })
      },
      complete: function () {
        _this.getSelfDeliveryList()
      }
    })
  }
  getSelfDeliveryList = () => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=AppShop/getSelfDeliveryList',
      data: {
        sub_shop_app_id: _this.franchiseeId
      },
      success: function (res) {
        if (res.data.store_list_data) {
          let deliveryList = res.data.store_list_data
          if (_this.data.statusFail) {
            let centerLat = deliveryList[0].latitude
            let centerLng = deliveryList[0].longitude
            let latitude = deliveryList[0].latitude
            let longitude = deliveryList[0].longitude
            let deliveryId = deliveryList[0].id
            if (_this.data.deliveryId) {
              deliveryList.map(item => {
                if (item.id == _this.data.deliveryId) {
                  centerLat = item.latitude
                  centerLng = item.longitude
                  latitude = item.latitude
                  longitude = item.longitude
                  deliveryId = item.id
                }
              })
            }
            _this.setData({
              showMap: true,
              deliveryList: deliveryList,
              centerLat: centerLat,
              centerLng: centerLng,
              'markers[0].latitude': latitude,
              'markers[0].longitude': longitude,
              'markers[0].callout': '',
              deliveryId: deliveryId
            })
          } else {
            _this.calculationDistance(deliveryList)
          }
        }
      }
    })
  }
  calculationDistance = data => {
    console.log(1)
    let deliveryList = data
    let _this = this
    for (let i = 0; i < deliveryList.length; i++) {
      deliveryList[i].distance = parseInt(
        app.calculationDistanceByLatLng(
          _this.selfLocation.lat,
          _this.selfLocation.log,
          deliveryList[i].latitude,
          deliveryList[i].longitude
        )
      )
    }
    for (let i = 0; i < deliveryList.length; i++) {
      for (let j = i + 1; j < deliveryList.length; j++) {
        if (deliveryList[i].distance > deliveryList[j].distance) {
          let tmp = deliveryList[i]
          deliveryList[i] = deliveryList[j]
          deliveryList[j] = tmp
        }
      }
    }
    this.setData({
      showMap: true,
      deliveryList: deliveryList
    })
    _this.showCallout()
  }
  showCallout = () => {
    let deliveryList = this.data.deliveryList
    let deliveryId = this.data.deliveryId
    let _this = this
    let index = -1
    for (let i = 0; i < deliveryList.length; i++) {
      if (deliveryList[i].id == deliveryId) {
        index = i
      }
    }
    index = index < 0 ? 0 : index
    this.setData({
      centerLat: deliveryList[index].latitude,
      centerLng: deliveryList[index].longitude,
      'markers[0].latitude': deliveryList[index].latitude,
      'markers[0].longitude': deliveryList[index].longitude,
      'markers[0].callout': index == 0 ? _this.callout : '',
      deliveryId: deliveryList[index].id
    })
  }
  selectDelivery = event => {
    let index = event.currentTarget.dataset.index
    let deliveryList = this.data.deliveryList
    let _this = this
    this.setData({
      centerLat: deliveryList[index].latitude,
      centerLng: deliveryList[index].longitude,
      'markers[0].latitude': deliveryList[index].latitude,
      'markers[0].longitude': deliveryList[index].longitude,
      'markers[0].callout':
        index == 0 && !_this.data.statusFail ? _this.callout : '',
      deliveryId: deliveryList[index].id
    })
  }
  sureDelivery = () => {
    let _this = this
    let deliveryId = this.data.deliveryId
    let pages = app.getCurrentPages()
    let prePage = pages[pages.length - 2]
    let deliveryList = this.data.deliveryList
    for (let i = 0; i < deliveryList.length; i++) {
      if (deliveryList[i].id == deliveryId) {
        let setDataObj = {}
        if (_this.isFranchisee) {
          setDataObj[`mulShopsInfo.${_this.franchiseeId}.selectDelivery`] =
            deliveryList[i]
          setDataObj[`mulShopsInfo.${_this.franchiseeId}.tostoreOrderType`] = ''
          setDataObj[`mulShopsInfo.${_this.franchiseeId}.dateIndex`] = ''
          setDataObj[`mulShopsInfo.${_this.franchiseeId}.tostoreDateTime`] = ''
          setDataObj[`mulShopsInfo.${_this.franchiseeId}.tostoreWeekTime`] = ''
        } else {
          setDataObj['selectDelivery'] = deliveryList[i]
          setDataObj['tostoreOrderType'] = ''
          setDataObj['dateIndex'] = ''
          setDataObj['tostoreDateTime'] = ''
          setDataObj['tostoreWeekTime'] = ''
        }
        prePage.setData(setDataObj)
      }
    }
    app.turnBack()
  }
  getAppECStoreConfig = () => {
    app.getAppECStoreConfig(res => {
      this.setData({
        storeStyle: res.color_config
      })
    }, this.franchiseeId)
  }

  render() {
    const {
      centerLng,
      centerLat,
      controls,
      markers,
      showMap,
      deliveryList,
      storeStyle,
      statusFail,
      deliveryId
    } = this.state
    console.log('this.state', this.state)

    return (
      <div className="official-page goods-delivery-list">
        <TopNav title="选择自提点" />
        {showMap && (
          <div className="map-wrap">
            {centerLng && centerLat &&
              <Map
                longitude={centerLng}
                latitude={centerLat}
                scale="14"
                controls={controls}
                markers={markers}
              ></Map>
            }
          </div>
        )}
        <div className="delivery-list-box">
          {deliveryList.map((item, index) => {
            return (
              <div
                className="delivery-list"
                key={item.id}
                onClick={this.selectDelivery}
                data-index={index}
              >
                <span className="ico-moon icon-goods-location"></span>
                <div className="delivery-list-content">
                  <div className="delivery-list-title">
                    {item.contact_name + ' ' + item.contact_phone}
                  </div>
                  <div className="delivery-list-detail">
                    {item.region_data.region_string + item.address_detail}
                  </div>
                  {!statusFail && (
                    <div>
                      {index == 0 && (
                        <span
                          className="delivery-lately"
                          style={convertLineStyleData(
                            'color:' +
                            storeStyle.theme +
                            ';border-color:' +
                            storeStyle.theme
                          )}
                        >
                          离你最近
                        </span>
                      )}
                      <span className="delivery-list-distance">
                        {'距离当前定位' + item.distance + '米'}
                      </span>
                    </div>
                  )}
                </div>
                <label
                  style={convertLineStyleData(
                    deliveryId == item.id ? 'color:' + storeStyle.theme : ''
                  )}
                  className={
                    'delivery-check-box ico-moon icon-success-tip ' +
                    (deliveryId == item.id ? 'checked' : '')
                  }
                ></label>
              </div>
            )
          })}
        </div>
        <div
          className="sure-delivery"
          style={convertLineStyleData('background:' + storeStyle.theme)}
          onClick={this.sureDelivery}
        >
          选为自提点
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/goods-delivery-list/GoodsDeliveryList.jsx